import { Controller } from "@hotwired/stimulus"

// Controller to manage country/city select dependency
// Uses advanced-select controllers for both country and city
export default class extends Controller {
  static targets = ["citySelect", "countrySelect"]

  connect() {
    // On initial load, check if city should be disabled
    if (this.hasCountrySelectTarget && this.hasCitySelectTarget) {
      const countryCode = this.getCountryValue()
      if (!countryCode) {
        this.disableCitySelect()
      }
    }
  }

  getCountryValue() {
    if (!this.hasCountrySelectTarget) return null

    // For advanced-select, find the hidden field inside
    const hiddenField = this.countrySelectTarget.querySelector('input[type="hidden"]')
    if (hiddenField) {
      return hiddenField.value
    }

    // Fallback for regular select
    return this.countrySelectTarget.value
  }

  // Called when country changes via advanced-select:change event
  onCountryChange(event) {
    // Get country code from event detail or fall back to getting it directly
    let countryCode
    if (event.detail?.value) {
      countryCode = event.detail.value
    } else {
      countryCode = this.getCountryValue()
    }

    // Reset the city select with new country code
    this.resetCitySelect(countryCode)
  }

  resetCitySelect(countryCode) {
    if (!this.hasCitySelectTarget) return

    const citySelectController = this.getCitySelectController()

    if (citySelectController) {
      // Update country code (will clear city and update API URL)
      citySelectController.updateCountryCode(countryCode)
    }
  }

  getCitySelectController() {
    if (!this.hasCitySelectTarget) return null

    // The citySelectTarget IS the advanced-select element
    // So we can get the controller directly from it
    return this.application.getControllerForElementAndIdentifier(
      this.citySelectTarget,
      "advanced-select"
    )
  }

  disableCitySelect() {
    const citySelectController = this.getCitySelectController()
    if (citySelectController) {
      citySelectController.disable()
    }
  }

  enableCitySelect() {
    const citySelectController = this.getCitySelectController()
    if (citySelectController) {
      citySelectController.enable()
    }
  }
}
